import { useState, useEffect, FunctionComponent, } from 'react';
import { Button, Input } from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import ExtraPaymentsAPI from '../../api/extraPayments';
import { paymentType } from '../../types/extraPayments';

// Based on the dictionary page, but currently backend doesn't include all the same features as other dictionary pages. So no delete reason, no description and deleted are not displayable
const EditPaymentTypes: FunctionComponent = () => {
    const [paymentTypes, setPaymentTypes] = useState(Array<paymentType>());
    const [newPaymentType, setNewPaymentType] = useState('');

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refresh = () => {
        ExtraPaymentsAPI.GetAllSlippsPayments().then(res => {
            setPaymentTypes(res._payments);
        })
    }
    const addPaymentType = () => {
        ExtraPaymentsAPI.AddTypeOfPayment(newPaymentType).then(res => {
            setNewPaymentType("");
            refresh();
        });
    }
    const confirmDelete = (id: number) => {
        ExtraPaymentsAPI.DeleteExistingPayment(id).then(res => {
            refresh();
        });
    }

    return (
        <div className="flex justify-center">
            <div className="w-full flex items-start justify-center" >
                <div className="w-1/2">
                    <div className="w-5/6">
                        {
                            paymentTypes !== undefined && paymentTypes.filter(type => type.visible === true).map(row => (
                                <Dictionary name={row.type_name} object={row} deleted={false} description='' id={row.id} deleteProperty={(row: paymentType) => confirmDelete(row.id)}></Dictionary>
                            ))
                        }
                    </div>
                </div>
                <div className="flex flex-wrap w-5/12">
                    <div className="w-full">
                        <br />
                        <Input
                            multiline={false}
                            label_text="Payment Type Name"
                            help_text="Please type in a name for the new payment type"
                            type="text"
                            value={newPaymentType}
                            width={50}
                            onTextChange={(value: string) => setNewPaymentType(value)}
                        />
                    </div>
                    <br />
                    <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addPaymentType()} >
                        Add Payment Type
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default EditPaymentTypes;
